import type {
  FeedbackData,
  JoinResponse,
  ReservePlacement,
  SendFeedback
} from '@/models/interface/classFeedback';
import type {
  ObserveReq,
  ObserveAmountRes,
  ObserveRes,
  CurrentReverse,
  Characteristic
} from '@/models/interface/tutorClass';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';
import type { AxiosResponse } from 'axios';

export class TutorClassService extends ApiFactory {
  constructor() {
    super('TutorClass');
  }
  /**
   *  取得已使用旁聽次數
   */
  fetchObserveAmount(): Promise<ApiDataResponse<ObserveAmountRes>> {
    return super.get('GetObserveAmount');
  }
  /**
   *  加入旁聽
   * @param classId 課程ID
   */
  fetchObserve(classId: ObserveReq): Promise<ApiDataResponse<ObserveRes>> {
    return super.post(`Observe?classId=${classId}`, '');
  }
  /**
   * 取得該課程目前的候位狀態
   * @param classIds 課程ID陣列
   */
  getCurrentReverse(classIds: string[]): Promise<ApiDataResponse<CurrentReverse[]>> {
    return super.post('GetRoomMembers', classIds);
  }

  getLimitForRoom(param: string): Promise<AxiosResponse<Record<string, string[]>>> {
    return super.get('GetLimitForRoom?' + param);
  }

  /**
   * 查詢老師特質
   * @param teacherId 老師ID
   */
  characteristic(teacherId: number): Promise<ApiDataResponse<Characteristic[]>> {
    return super.get(`Characteristic/${teacherId}`);
  }

  /**
   * 取得該會員未評分課程資料
   */
  unratedCourses(): Promise<ApiDataResponse<FeedbackData[]>> {
    return super.get(`UnratedCourses`);
  }

  /**
   * 課程評分
   * @param data SendFeedback
   */
  courseRating(data: SendFeedback): Promise<ApiDataResponse<boolean>> {
    return super.post(`CourseRating`, data);
  }

  /**
   * 提早候位
   * @param classId
   * @param type 0預約 1取消預約
   * @returns
   */
  earlyReservePlacement(classId: string, type: number): Promise<ApiDataResponse<boolean>> {
    return super.get(`EarlyReservePlacement?class_id=${classId}&type=${type}`);
  }

  /**
   * 一般候位
   * @param classId
   * @param lv
   * @param lvStep
   * @returns
   */
  reservePlacement(
    classId: string,
    lv: number,
    lvStep: number
  ): Promise<ApiDataResponse<ReservePlacement>> {
    return super.get(`PreJoin?class_id=${classId}&Lv=${lv}&Levels_step=${lvStep}`);
  }

  /**
   * Join class
   * @param classId
   * @returns
   */
  teacherJoin(classId: string): Promise<ApiDataResponse<JoinResponse>> {
    return super.get(`TeacherJoin?meetingId=${classId}`);
  }

  /**
   * 申請加開
   * @param classId
   * @returns
   */
  applyMore(classId: string): Promise<ApiDataResponse<JoinResponse>> {
    return super.get(`ClassApplication?cindx=411&class_id=${classId}`);
  }
}
